import { Divider, Grid, Slider, Typography, useTheme } from '@mui/material';
import UseCurrency from '@shared/hooks/UseCurrency';
import React from 'react';

import { sxStyled } from './styles';

const FillterPrices = ({ flightFilters }) => {
  const { currency } = UseCurrency();
  const {
    priceSelected,
    minAndMaxPriceRange,
    handleChangePrice,
  } = flightFilters;

  const theme = useTheme();
  const sxStyle = sxStyled(theme);

  const [localPrice, setLocalPrice] = React.useState(priceSelected);

  React.useEffect(() => {
    if (
      localPrice < minAndMaxPriceRange[0] ||
      localPrice > minAndMaxPriceRange[1]
    ) {
      setLocalPrice(minAndMaxPriceRange[1]);
    } else {
      setLocalPrice(priceSelected);
    }
  }, [priceSelected, minAndMaxPriceRange]);

  return (
    <Grid item lg={12} sm={12} xs={12} sx={sxStyle.filterBox}>
      <Typography
        style={{
          fontSize: '15px',
          color: 'black',
          fontWeight: '600',
        }}
      >
        Precios
      </Typography>
      <Grid item xs>
        <Slider
          min={minAndMaxPriceRange[0]}
          max={minAndMaxPriceRange[1]}
          value={localPrice}
          onChange={(_, value) => setLocalPrice(value)}
          onChangeCommitted={(_, value) => handleChangePrice(_, value)}
          color={'tertiary'}
          size="small"
        />
        <Typography
          style={{
            fontSize: '14px',
            color: 'black',
          }}
        >
          {'Hasta ' + currency(localPrice)}
        </Typography>
      </Grid>

      <Divider sx={sxStyle.filterBoxDivider} />
    </Grid>
  );
};

export default FillterPrices;
